'use strict'
import { convertConfiguredTime } from '../../../components/helpers.js'

export function getExtendedVehicleName (forkliftTruckRequest) {
  const vehicleTypeName = forkliftTruckRequest.vehicleType && forkliftTruckRequest.vehicleType.name || null
  if (forkliftTruckRequest.vehicle) {
    const vehicleName = forkliftTruckRequest.vehicle.name
    if (!vehicleTypeName || vehicleName.includes(vehicleTypeName)) {
      return vehicleName
    } else {
      return vehicleTypeName + ' ' + vehicleName
    }
  } else {
    return vehicleTypeName
  }
}

export function formatAssignmentType (forkliftTruckRequest = {}, short = false, mobile = false) {
  let status = ''
  if (!forkliftTruckRequest.id) {
    return status
  }

  let assign = ''
  if (!short) {
    if (mobile && forkliftTruckRequest.assignmentType === 'current') {
      assign = ''
    } else if (forkliftTruckRequest.assignedBrigade) {
      assign = `\nТС назначено на: ${forkliftTruckRequest.assignedBrigade.brigadeGUIName} (${convertTime(forkliftTruckRequest.assignedBrigade.workDate)} ${forkliftTruckRequest.assignedBrigade.workShift.name}). `
    } else {
      assign = 'ТС не назначено ни одной из бригад. '
    }
  }

  switch (forkliftTruckRequest.assignmentType) {
    case 'none':
      break
    case 'inList':
      status = 'Ожидайте назначения'
      break
    case 'next':
      status = mobile || short ? `${mobile ? 'Ваша' : 'Данная'} бригада следующая` : ''
      break
    case 'current':
      status = mobile || short ? `ТС назначено на ${mobile ? 'вашу' : 'данную'} бригаду` : ''
      break
  }

  return assign + status
}

export function getAssignmentTypeColor (type) {
  switch (type) {
    case 'none':
      return 'rgba(0, 0, 0, 0.3)'
    case 'inList':
      return 'rgba(255, 255, 0, 0.3)'
    case 'next':
      return 'rgba(0, 142, 255, 0.3)'
    case 'current':
      return 'rgba(0, 255, 0, 0.3)'
  }
}

function convertTime (ms) {
  return convertConfiguredTime(ms, { month: true, date: true, hour: true, min: true })
}
